/* */

const stepToggle = document.querySelector('.js-rdv-steps-advance');

if (stepToggle) {
  stepToggle.addEventListener('click', function() {
    const parentEl = this.parentNode;
    const activeClass = 'offcanvas__step--active'
    parentEl.classList.remove(activeClass);
    parentEl.nextElementSibling.classList.add(activeClass);

    document.querySelector(`[data-offcanvas="form"]`).addEventListener('close', (e) => {
      parentEl.nextElementSibling.classList.remove(activeClass);
      parentEl.classList.add(activeClass);
    })
  })
}
